module.exports = __webpack_public_path__ + "img/digi-crush-1.73e06d97.png";